import { environment } from '@/environments/environment'
export default [
  { name: 'getStore', url: `${environment.entelApiUrl}/company-configs/{id}/daily-slots-configs`, method: 'get', notCancel: true},
  { name: 'putStore', url: `${environment.entelApiUrl}/company-configs/{id}/daily-slots-configs`, method: 'put', notCancel: true}

]